export default {"src":"/_next/static/media/hot.cc0f6a15.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};